import * as angular from 'angular';
import {SignalRStateChange} from "../services/hubs/signalr-hub";
import HubServiceName, {HubService} from "../services/hubs/hub.service";

export interface ConnectionStatusScope extends angular.IScope {
  notConnected: boolean;
}

export default angular
  .module('aps.directives.connectionStatus', [HubServiceName])
  .directive('connectionStatus', (hubService: HubService,
                                  $timeout: angular.ITimeoutService) => {
    return {
      scope: {},
      template: '<span class="not-connected" ng-if="notConnected" title="Not Connected"><i class="fa fa-ban" /></span>',
      link: (scope: ConnectionStatusScope) => {
        scope.notConnected = true;
        var hub = hubService.createHub('chat', {
          listeners: null,
          methods: null,
          onStateChange: (change: SignalRStateChange) => {
            $timeout(() => {
              scope.notConnected = (change.newState !== signalR.HubConnectionState.Connected);
            });
          }
        });

        scope.$on('$destroy', () => {
          if (hub) {
            hub.uninitialize();
          }
        });
      }
    };
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/directives/connectionStatus.directive.ts